/**
 * Service for bill-related operations.
 * These endpoints return documents (PDFs) and open in new tabs.
 */
export const billService = {
  /**
   * Open a bill in a new tab.
   * @param {string} billId - The bill ID to view
   */
  viewBill: (billId) => {
    if (billId) {
      window.open(`/assist/api/bill/view?billId=${encodeURIComponent(billId)}`, '_blank');
    }
  },

  /**
   * Open all bills download in a new tab.
   */
  downloadAllBills: () => {
    window.open('/assist/api/bill/viewAll', '_blank');
  },
};
